export default __webpack_public_path__ + "static/media/marbles-help.114c5466.png";